import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';

export const proceduresRoute: RouteConfig = {
  path: '',
  name: 'procedureList',
  component: () => import(/* webpackChunkName: "ProcedureList" */ '@/views/mainRoute/procedure/List.vue'),
  beforeEnter: (to, from, next) => {
    store
      .dispatch('procedure/list')
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.PROCEDURE_CANNOT_LIST }));
  }
};
